import React from 'react';

/**
 * Sedan from above as bold line art (copied as is from z1-ui-main): body
 * outline, hood line, windshield, roof, side glass, rear glass, trunk line,
 * mirrors and light bars. Stroke-only in currentColor. Purely decorative:
 * every reading lives in the tiles around it.
 */
export const CarTopSilhouette = ({ className }) => (
	<svg
		viewBox="0 0 100 200"
		aria-hidden="true"
		focusable="false"
		fill="none"
		stroke="currentColor"
		strokeWidth={3}
		strokeLinejoin="round"
		strokeLinecap="round"
		className={`oem-car-silhouette ${className || ''}`}
	>
		{/* Body */}
		<path d="M50 5 C33 5 20 8 18 22 L15 44 C13 52 13 60 15 68 L15 128 C13 136 13 146 15 154 L17 176 C19 191 33 195 50 195 C67 195 81 191 83 176 L85 154 C87 146 87 136 85 128 L85 68 C87 60 87 52 85 44 L82 22 C80 8 67 5 50 5 Z" />
		{/* Hood line, windshield, roof, side glass, rear glass, trunk line */}
		<g strokeWidth={2.5}>
			<path d="M24 34 C36 29 64 29 76 34" />
			<path d="M27 58 C38 53 62 53 73 58 L79 82 C61 77 39 77 21 82 Z" />
			<rect x="25" y="86" width="50" height="54" rx="5" />
			<path d="M21 84 L17 74 L17 152 L21 142 Z" />
			<path d="M79 84 L83 74 L83 152 L79 142 Z" />
			<path d="M25 144 C38 149 62 149 75 144 L72 166 C60 172 40 172 28 166 Z" />
			<path d="M23 174 C36 180 64 180 77 174" />
		</g>
		{/* Mirrors */}
		<g fill="currentColor" strokeWidth={2}>
			<path d="M15 66 L7 71 L15 75 Z" />
			<path d="M85 66 L93 71 L85 75 Z" />
		</g>
		{/* Headlights and taillights */}
		<g strokeWidth={4}>
			<path d="M22 13 L34 10" />
			<path d="M78 13 L66 10" />
			<path d="M22 187 L34 190" />
			<path d="M78 187 L66 190" />
		</g>
	</svg>
);
